/**
 * Utilitários de validação de IDs de contas de anúncios
 */
import { t } from '../i18n/index.js';

/**
 * Valida ID de conta Meta (Facebook/Instagram)
 * Formato: act_XXXXXXXXX (6-20 dígitos após act_) ou apenas números
 */
export function validateMetaAdAccountId(id) {
  if (!id || typeof id !== 'string') return false;
  const cleanId = id.trim().toLowerCase();
  const metaPattern = /^(act_)?\d{6,20}$/;
  return metaPattern.test(cleanId);
}

/**
 * Valida ID de conta Google Ads
 * Formato: XXX-XXX-XXXX (3 dígitos, hífen, 3 dígitos, hífen, 4 dígitos)
 */
export function validateGoogleAdAccountId(id) {
  if (!id || typeof id !== 'string') return false;
  const cleanId = id.trim();
  const googlePattern = /^\d{3}-\d{3}-\d{4}$/;
  return googlePattern.test(cleanId);
}

/**
 * Formata ID de conta Meta para garantir formato correto
 */
export function formatMetaAdAccountId(id) {
  if (!id) return '';
  const cleanId = id.trim().toLowerCase();

  if (/^\d{6,20}$/.test(cleanId)) {
    return `act_${cleanId}`;
  }

  if (/^act_\d{6,20}$/.test(cleanId)) {
    return cleanId;
  }

  return cleanId;
}

/**
 * Formata ID de conta Google Ads para garantir formato correto
 */
export function formatGoogleAdAccountId(id) {
  if (!id) return '';
  const cleanId = id.trim().replace(/\D/g, '');

  if (cleanId.length === 10) {
    return `${cleanId.slice(0, 3)}-${cleanId.slice(3, 6)}-${cleanId.slice(6, 10)}`;
  }

  return id.trim();
}

/**
 * Retorna mensagem de erro amigável para IDs inválidos
 */
function getValidationErrorMessage(platform, id) {
  if (platform === 'meta') {
    return t('validation.invalidMetaId', { id });
  }

  if (platform === 'google') {
    return t('validation.invalidGoogleId', { id });
  }

  return t('validation.invalidId', { id });
}

/**
 * Valida e formata array de IDs de contas de anúncios
 */
export function validateAdAccountIds(ids, platform) {
  const validator = platform === 'meta' ? validateMetaAdAccountId : validateGoogleAdAccountId;
  const formatter = platform === 'meta' ? formatMetaAdAccountId : formatGoogleAdAccountId;

  const valid = [];
  const invalid = [];
  const errors = [];

  ids.forEach(id => {
    const formattedId = formatter(id);

    if (validator(formattedId)) {
      valid.push(formattedId);
    } else {
      invalid.push(id);
      errors.push(getValidationErrorMessage(platform, id));
    }
  });

  return { valid, invalid, errors };
}
